import { render, staticRenderFns } from "./CpurchasingCreate.vue?vue&type=template&id=547f0f8e&scoped=true"
import script from "./CpurchasingCreate.vue?vue&type=script&lang=js"
export * from "./CpurchasingCreate.vue?vue&type=script&lang=js"
import style0 from "./CpurchasingCreate.vue?vue&type=style&index=0&id=547f0f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f0f8e",
  null
  
)

export default component.exports